
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('variant-radios').forEach(function(picker) {
      var scriptEl = picker.querySelector('script[type="application/json"]');
      if (!scriptEl) return;

      var variants = JSON.parse(scriptEl.textContent);
      var fieldsets = picker.querySelectorAll('fieldset');
      var optionCount = fieldsets.length;

      function getSelectedOptions() {
        var selected = [];
        fieldsets.forEach(function(fs) {
          var checked = fs.querySelector('input:checked');
          selected.push(checked ? checked.value : null);
        });
        return selected;
      }

      function updateAvailability() {
        var selected = getSelectedOptions();

        fieldsets.forEach(function(fs, optionIndex) {
          var inputs = fs.querySelectorAll('input[type="radio"]');
          inputs.forEach(function(input) {
            var label = input.nextElementSibling;
            if (!label) return;

            // Check if ANY variant with this option value is available
            var isAvailable = variants.some(function(v) {
              if (!v.available) return false;
              // This option must match
              if (v["option" + (optionIndex + 1)] !== input.value) return false;
              // Other selected options must also match (if selected)
              for (var i = 0; i < optionCount; i++) {
                if (i === optionIndex) continue;
                if (selected[i] && v["option" + (i + 1)] !== selected[i]) return false;
              }
              return true;
            });

            if (isAvailable) {
              label.classList.remove('unavailable');
            } else {
              label.classList.add('unavailable');
            }
          });
        });
      }

      // Run on load and on any change
      updateAvailability();
      picker.addEventListener('change', updateAvailability);
    });
  });
})();
